export const PROVIDER_META: Record<string, { color: string; label: string }> = {
  'openai':     { color: '#000000', label: 'OpenAI' },
  'anthropic':  { color: '#c96442', label: 'Anthropic' },
  'google':     { color: '#4285f4', label: 'Google' },
  'x-ai':       { color: '#1a1a1a', label: 'xAI' },
  'meta-llama': { color: '#0866ff', label: 'Meta' },
  'deepseek':   { color: '#1a6db5', label: 'DeepSeek' },
  'moonshotai': { color: '#7c3aed', label: 'Moonshot' },
  'mistralai':  { color: '#f97316', label: 'Mistral' },
  'qwen':       { color: '#7b5ea7', label: 'Qwen' },
  'perplexity': { color: '#20b2aa', label: 'Perplexity' },
  'cocoon':     { color: '#34c759', label: 'Cocoon' },
}

export function getProvider(modelId: string): { color: string; label: string } {
  const key = modelId.split('/')[0] ?? ''
  return PROVIDER_META[key] ?? { color: '#8e8e93', label: key }
}
